import ListoryStore from '@/store';
import { Poi } from '@/models/poi';
import { Experience, Favorite } from '@/constants';
import { PoiFilterSet, RouteFilterSet } from '@/models/filter';
import { Route } from '@/models/route';
import FavoriteHelper from '@/services/favorite-helper';

export default class FilterHelper {
    // poi filtering
    public static createPoiFilterSet(): PoiFilterSet {
        const filterSet = new PoiFilterSet();
        filterSet.topicFilters = [];
        filterSet.experienceFilters = [];
        filterSet.communityFilters = [];
        filterSet.favoriteFilters = [];
        filterSet.unlockFilters = [];
        return filterSet;
    }

    public static duplicatePoiFilterSet(filterSet: PoiFilterSet): PoiFilterSet {
        const result = new PoiFilterSet();
        result.topicFilters = Array.from(filterSet.topicFilters);
        result.experienceFilters = Array.from(filterSet.experienceFilters);
        result.communityFilters = Array.from(filterSet.communityFilters);
        result.favoriteFilters = Array.from(filterSet.favoriteFilters);
        result.unlockFilters = Array.from(filterSet.unlockFilters);
        return result;
    }

    public static getFilteredPois(store: ListoryStore, pois: Poi[], filterSet: PoiFilterSet): Poi[] {
        let result: Poi[];

        // apply topic filter any or copy poi array
        if (filterSet.topicFilters.length > 0) {
            result = pois.filter(poi => poi.topics.some(topic => filterSet.topicFilters.indexOf(topic) >= 0));
        } else {
            result = Array.from(pois);
        }

        // apply community filter
        if (result.length > 0 && filterSet.communityFilters.length > 0) {
            result = result.filter(poi => filterSet.communityFilters.indexOf(poi.community) >= 0);
        }

        // apply experience filter
        if (result.length > 0 && filterSet.experienceFilters.length > 0) {
            if (filterSet.experienceFilters.indexOf(Experience.SPECIAL) >= 0) {
                result = result.filter(poi => poi.content_ar_experiences && poi.content_ar_experiences.length > 0);
            } else {
                result = result.filter(poi => !poi.content_ar_experiences || poi.content_ar_experiences.length <= 0);
            }
        }

        // apply unlock filter
        if (result.length > 0 && filterSet.unlockFilters.length > 0) {
            result = result.filter(poi => filterSet.unlockFilters.indexOf(poi.state) >= 0);
        }

        // apply favorit filter
        if (result.length > 0 && filterSet.favoriteFilters.length > 0) {
            if (filterSet.favoriteFilters.indexOf(Favorite.FAVORITE) >= 0) {
                result = result.filter(poi => FavoriteHelper.isFavorite(store, poi.id));
            } else {
                result = result.filter(poi => !FavoriteHelper.isFavorite(store, poi.id));
            }
        }

        return result;
    }

    public static isPoiFilterSetModified(filterSet: PoiFilterSet): boolean {
        return (
            filterSet.topicFilters.length !== 0 ||
            filterSet.experienceFilters.length !== 0 ||
            filterSet.communityFilters.length !== 0 ||
            filterSet.favoriteFilters.length !== 0 ||
            filterSet.unlockFilters.length !== 0
        );
    }

    public static isUnlockFilterModified(filterSet: PoiFilterSet): boolean {
        return filterSet.unlockFilters.length !== 0;
    }

    // route filtering
    public static createRouteFilterSet(): RouteFilterSet {
        const filterSet = new RouteFilterSet();
        filterSet.profileFilters = [];
        return filterSet;
    }

    public static duplicateRouteFilterSet(filterSet: RouteFilterSet): RouteFilterSet {
        const result = new RouteFilterSet();
        result.profileFilters = Array.from(filterSet.profileFilters);
        return result;
    }

    public static getFilteredRoutes(routes: Route[], filterSet: RouteFilterSet): Route[] {
        if (filterSet.profileFilters.length > 0) {
            return routes.filter(route => route.profiles.some(topic => filterSet.profileFilters.indexOf(topic) >= 0));
        } else {
            return Array.from(routes);
        }
    }

    public static isRouteFilterSetModified(filterSet: RouteFilterSet): boolean {
        return filterSet.profileFilters.length !== 0;
    }
}
